import React from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import InputIcon from "react-multi-date-picker/components/input_icon";

import moment from "moment-jalaali";

const PersianDataPicker = (props) => {
  const { form, field } = props;

  return (
    <div>
      <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 text-white">
        {props.label}
      </label>
      <div style={{ direction: "ltr", zIndex: 9999 }}>
        <DatePicker
          onChange={(value) => {
            form.setFieldValue(field["name"], value.toDate());
            if (props.alsoOnchange) {
              props.alsoOnchange(value.toDate());
            }
          }}
          value={
            field.value
              ? moment(field.value).toDate()
              : !props.disable_today
              ? form.setFieldValue(field["name"], moment().toDate())
              : "25"
          }
          format={props.format ?? "YYYY/MM/DD"}
          calendar={persian}
          locale={persian_fa}
          calendarPosition="bottom-right"
          plugins={props.hasTime ? [<TimePicker position="left" />] : []}
          render={<InputIcon />}
        />
      </div>
    </div>
  );
};

export default PersianDataPicker;
